<template>
    <div class="privacy">
            
        <div class="privacy-body">

          <div class="privacy-body__container">
            <h1 class="privacy-body__headline">PRIVACY POLICY</h1>
              <p class="privacy-body__paragraph">
                Thank you for visiting our web site (the “Website”). Because Your privacy is important to us (hereinafter, “we”, “Hunter/HPR Partners, LLC” or “us”), we have prepared this Privacy Statement to walk you (hereinafter, “You”) through our practices regarding our collection, use, and disclosure of the information we collect about You through this Website, as well as the information we generally collect about clients or prospective clients through providing our services.
              </p>
              <p class="privacy-body__paragraph">
                Hunter/HPR Partners, LLC is committed to providing You with notice as required by law if we make material changes to this Privacy Statement, Your continued use of the Website or our services will signify acceptance of the terms of the updated Privacy Statement.
              </p>
            <h2 class="privacy-body__heading">1. The Information We Collect.</h2>
            <p class="privacy-body__paragraph">
              Hunter/HPR Partners, LLC collects information from users of our Website, potential clients and clients of our services, suppliers and vendors (actual and potential), applicants for employment and participants in events that we may organize or promote. Depending on the nature of the services provided by Hunter/HPR Partners, LLC, we may receive information from You (a Website visitor, potential client, or client) directly, or from our clients, who may send us Your information in order to fulfill a service to You on their behalf. The information may include Your name, mailing address, email address, phone number, credit card information and other data required to provide You with the product or service You requested.
              <br/>&nbsp;<br/>
              We may automatically collect certain information about the computer or devices (including mobile devices or tablets) You use to access the Website or services. As described further below, we may collect and analyze information such as (a) IP addresses, location information, unique device identifiers, IMEI and TCP/IP address, and other information about Your computer or device(s), browser types, browser language, operating system, mobile device carrier information, the state or country from which You accessed the Website or services; and (b) information related to the ways in which You interact with the Website or services, such as: referring and exit web pages and URLs, platform type, the number of clicks, domain names, landing pages, pages and content viewed and the order of those pages, statistical information about the use of the Website or services, the amount of time spent on particular pages, the date and time You used the Website or services, the frequency of Your use of the Website or services, error logs, and other similar information. As described further below, we may use third-party analytics providers and technologies, including “Cookies”, as defined below, and similar tools, to assist in collecting this information.
              <br/>&nbsp;<br/>
              Whether for our own purposes of those of our clients, we may also collect data about Your use of our Website, our ads, or ads and sites we track on behalf of our clients, through the use of Internet server logs (where we store Website activity) and cookies and/or tracking pixels.  We may be provided information relating to visitors to the Website by third-parties that use tracking technology to identify such visitors based on their IP addresses.
              <br/>&nbsp;<br/>
              If You wish to opt out of interest-based advertising, by opting out of many of the online advertising and data platforms that provide this advertising, You may go to the DAA opt-out portal at <a href="http://aboutads.info">http://aboutads.info</a>, or the NAI opt-out portal at <a href="http://www.networkadvertising.org">http://www.networkadvertising.org</a>.
              <br/>&nbsp;<br/>
              Some Cookies are placed in Your browser cache while those associated with Flash technologies are stored with Your Adobe Flash Player files. Tracking pixels (sometimes referred to as web beacons or clear GIFs) are tiny electronic tags with a unique identifier embedded in Websites, online ads and/or email, and that are designed to provide usage information like ad impressions or clicks, measure popularity of the Services and associated advertising, and to access user Cookies. We also may include web beacons in email messages, newsletters and other electronic communications to determine whether the message has been opened and for other analytics, personalization and advertising. As we adopt additional technologies, we may also gather additional information through other methods.
              <br/>&nbsp;<br/>
              Please note that You can change Your settings to notify You when a Cookie is being set or updated, or to block Cookies altogether. Please consult the “Help” section of Your browser for more information (e.g., Internet Explorer; Google Chrome; Mozilla Firefox; or Apple Safari). You can also manage the use of Flash technologies, including Cookies and local storage objects with the Flash management tools available at Adobe’s Website. Please note that by blocking any or all Cookies, You may not have access to certain features or offerings of the Services.
            </p>
            <h2 class="privacy-body__heading">2. How We Use the Information We Collect.</h2>
            <p class="privacy-body__paragraph">
              Hunter/HPR Partners, LLC uses the data we collect as follows:
              <ul>
                <li>For the purposes for which You provided it;</li>
                <li>To recognize and authenticate You on the services;</li>
                <li>To initiate or to provide the features, services and products available through the Website or our services;</li>
                <li>To send You information about Your relationship or transactions with us, account alerts, or other communications, such as newsletters to which You have subscribed;</li>
                <li>To contact You with information or surveys that we believe may be of interest to You both regarding our products and services and those of third parties;</li>
                <li>To process and respond to Your inquiries or to request Your feedback;</li>
                <li>For internal research and reporting;</li>
                <li>To improve the content and features of the Website or our services or develop new services;</li>
                <li>To enforce the legal terms that govern Your use of the Website or our services; and</li>
                <li>To administer and troubleshoot the Website or our services.</li>
                <li>To send You communications required by law or which are necessary to inform You about changes to the services we provide and this Privacy Policy. (These service messages will not include any promotional content and do not require prior consent when sent by email.)</li>
              </ul>
              <i>Please note that we may combine information that we collect from You and about You (including automatically-collected information) with information we obtain about You from our affiliates and/or non-affiliated third parties, and use such combined information in accordance with this Privacy Statement.</i>
              <br/>&nbsp;<br/>
              We may aggregate and/or de-identify information collected through the Website or services. We may use de-identified and/or aggregated data for any purpose, including without limitation for research and marketing purposes, and may also share such data with any third parties, including advertisers, promotional partners, and/or others.
            </p>
            <h2 class="privacy-body__heading">3. How We Disclose Your Information.</h2>
            <p class="privacy-body__paragraph">
              Hunter/HPR Partners, LLC will disclose Your information as follows:
              <ul>
                <li>To third parties who perform services on our behalf, including without limitation marketing, market research, customer support, data storage, analysis and processing, and legal services. (Specifically, Hunter/HPR Partners, LLC uses, among other companies, Mailchimp (a business of The Rocket Science Group LLC) to manage email correspondence with clients, prospective clients, and other business contacts. We may use other similar services in future.)</li>
                <li>To manage its relationships, correspondence, and record-keeping in respect of clients and prospective clients. (Hunter/HPR Partners, LLC currently uses Salesforce.com, among other companies, to support this activity.)</li>
                <li>To process financial records. (Hunter/HPR Partners, LLC uses Sage Global Services Limited, among other companies, to support this activity).</li>
                <li>To suppliers employed by our clients who will then fulfill the product or service requested to You directly.</li>
                <li>Where required to do so by law or in a good faith belief that such access, preservation, or disclosure is permitted by this Privacy Statement or reasonably necessary or appropriate for any of the following reasons: (a) to comply with legal process; (b) to enforce this Privacy Statement or other contracts with You, including investigation of potential violations thereof; (c) to respond to claims that any content violates the rights of third parties; (d) to respond to Your requests for customer service; and/or (e) to protect the rights, property, or personal safety of Hunter/HPR Partners, LLC, its agents and affiliates, its users, and the public. This includes exchanging information with other companies and organizations for fraud protection, and spam/malware prevention, and similar purposes.</li>
                <li>As part of business transactions, (including in contemplation of such transactions, e.g., due diligence), such as buying, merging with, or partnering with other businesses or as part of an asset sale.</li>
              </ul>
            </p>
            <h2 class="privacy-body__heading">4. Requests for Personal Information by Law Enforcement or Government Agencies.</h2>
            <p class="privacy-body__paragraph">
              Hunter/HPR Partners, LLC may be required to respond to subpoenas, court orders or be asked to respond to legitimate requests for Your personal information from law enforcement or government agencies. In such situations, we will release Your information to these organizations as we reasonably believe appropriate for us to comply with the law and to prevent against fraud. Hunter/HPR Partners, LLC will not provide You with these requests for information made by law enforcement or government agencies.
            </p>
          <h2 class="privacy-body__heading">5. Cookies, Web Pixels and Online Analytics</h2>
          <p class="privacy-body__paragraph">
            This section provides more information about that we, our Clients and our business partners may use, and how they work.
            <br/>&nbsp;<br/>
            <b>Cookies:</b> A Cookie is a small piece of code that is sent from a website You browse and stored in Your web browser. Cookies relay certain information to us or to third parties that enables us to: (a) recognize Your computer; (b) store Your preferences and settings; (c) understand the web pages You have visited; (d), enhance Your user experience by delivering content and advertisements specific to Your inferred interests; (e) perform searches and analytics; and (f) assist with security administrative functions.
            <br/>&nbsp;<br/>
            <b>Pixels or web beacons:</b> Pixels or web beacons may also communicate information from Your Internet browser to a web server. Pixels can be embedded in web pages, videos, or emails, and can allow a web server to read certain types of information from Your browser, check whether You have viewed a particular web page or email message, and determine, among other things, the time and date on which You viewed the Web beacon, the IP address of Your computer, and the URL of the web page from which the Web beacon was viewed.
            <br/>&nbsp;<br/>
            We sometimes work with third parties to advertise, provide or complement our Services, and these partners may set and access their own Cookies, pixel tags and similar technologies on Your device. Likewise, if You receive email from us, we may use these technologies to capture data such as when You open our message or click on any links or banners our email contains. This data allows us to gauge the effectiveness of our communications and marketing campaigns.
            <br/>&nbsp;<br/>
            The information collected and stored through these technologies includes IP address, unique identifiers, time stamps, browser type and other browser information, referring website, and more generally, what web pages You visit and how You interact with them, and what ads You view and how You interact with them. We and our partners, including Google Analytics, may also use these technologies for analyzing usage trends, assisting with fraud prevention, and providing certain features to You. To prevent Google Analytics from using Your information for analytics, You may install the Google Analytics Opt-out Browser Add-on by clicking <a href="https://tools.google.com/dlpage/gaoptout/">here</a>.
            <br/>&nbsp;<br/>
            <b>Twitter Tweet Button, Facebook Like Button and LinkedIn Button, YouTube and Instagram:</b> These are functions provided by Twitter, Facebook, LinkedIn, YouTube, Instagram respectively, companies with whom we are not related.  By simply clicking on these pushbuttons on the Website, the function makes it possible to share liking of Hunter/HPR Partners, LLC articles and other content on the relevant social media site, without having to exit the page. This way the user links his/her/its relevant social media profile to Hunter/HPR Partners, LLC and makes this information accessible to anyone on the web, subject to the terms of use and privacy policies of each social media platform.
          </p>
          <h2 class="privacy-body__heading">6. Notice Concerning Do-Not-Track Signals</h2>
          <p class="privacy-body__paragraph">
            Do Not Track (“DNT”) is a privacy preference that users can set in certain web browsers. We do not recognize or respond to browser initiated DNT signals, as the Internet industry is currently still working toward defining exactly what DNT means, what it means to comply with DNT, and a common approach to responding to DNT. You can learn more about Do Not Track <a href="https://allaboutdnt.com/">here</a>.
          </p>
          <h2 class="privacy-body__heading">7. Links to Other Sites</h2>
          <p class="privacy-body__paragraph">
            Our Website may contain links to other websites. Therefore, it is important that You know that our Privacy Statement does not extend to those third-party Websites, as their policy(ies) may differ from ours.
          </p>
            <h2 class="privacy-body__heading">8. Security</h2>
            <p class="privacy-body__paragraph">
              We have implemented administrative, technical, and physical security measures designed to protect against the loss, misuse, and/or alteration of Your information. These safeguards vary based on the sensitivity of the information that we collect and store. However, we cannot and do not guarantee that these measures will prevent every unauthorized attempt to access, use, or disclose Your information since despite our efforts, no Internet and/or other electronic transmissions can be completely secure.
              <br/>&nbsp;<br/>
              Additionally, we may process the information You provide to us either directly or by a third-party data processor appointed by us.  In common with a number of other websites, we may transfer the data that we collect from You to a cloud service provider which has data servers which are based in a variety of locations, including outside the European Economic Area (which includes all EU Member countries as well as Iceland, Liechtenstein and Norway; the “EEA”). By submitting Your personal data, You agree to this transfer and the storing and/or processing of Your personal data on these servers.  For any transfer, we will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy.
              <br/>&nbsp;<br/>
              Whenever we collect or process Your personal data, we’ll only keep it for as long as is necessary for the purpose for which it was collected.  At the end of that retention period, we will either deleted Your data completely or anonymized it, for example by aggregation with other data so that it can be used in a non-identifiable way for statistical analysis and business planning.
            </p>
            <h2 class="privacy-body__heading">9. Data Transfers</h2>
            <p class="privacy-body__paragraph">
              Our computer systems are currently based in the both the United States and EEA and we may process and store Your information in one or both of these locations.  As such, we may not provide the same level of protection as the privacy laws of Your jurisdiction. By providing us with Your information, You understand that Your personal information will be processed in the United States or the EEA. <br/>
              Additionally, we will ensure, through contractual clauses that Your data receives at least the same protection as if it were being processed inside the US and EEA.
              <br/>&nbsp;<br/>
              Moreover, any transfer of Your personal data will be subject to the applicable laws and the guiding principles of this Privacy Policy.
            </p>
            <h2 class="privacy-body__heading">10. Your Choices and Rights</h2>
            <p class="privacy-body__paragraph">
              You can review and update certain information by contacting us as described below. You can unsubscribe from marketing emails by clicking the “unsubscribe” link they contain.
              <br/>&nbsp;<br/>
              California Law permits visitors who are California residents to request certain information once per year regarding our disclosure of “personal information” (as that term is defined under applicable California law) to third parties for such third parties’ direct marketing purposes. To make such a request, please email us as described below with “Shine the Light” in the subject line or write to us at the contact information below.<br/>
              In addition, we work with various online advertising and data platforms in order to send online ads for our own benefit, and for the benefit of our clients – including through the use of Cookies and similar technologies described in Section 4, above.  If You are interested in more information about tailored browser advertising and how You can generally control Cookies from being put on Your computer or mobile browser to deliver tailored advertising (i.e., not just for the Services), You may visit the <a href="https://optout.networkadvertising.org/?c=1">Network Advertising Initiative’s Consumer Opt-Out Link</a> and/or the <a href="https://optout.aboutads.info/?c=2&lang=EN">Digital Advertising Alliance’s Consumer Opt-Out Link</a> to opt-out of receiving tailored advertising from companies that participate in those programs.
            </p>
            <h2 class="privacy-body__heading">11. Children’s Privacy</h2>
            <p class="privacy-body__paragraph">Our Website and services are intended for general audiences and not for children under the age of 13. If we become aware that we have collected personal information (as defined by the Children’s Online Privacy Protection Act) from children under the age of 13, we will take reasonable steps to delete it as soon as practical.</p>
            <h2 class="privacy-body__heading">12. How to Contact Us</h2>
            <p class="privacy-body__paragraph">
              If You have any questions regarding our privacy practices in the United States, You may contact Sam Mindel by mail at Hunter/HPR Partners, LLC, One World Trade Center, 67th Floor, New York, NY 10007, or email at <a href="mailto:smindel@hunterpr.com">smindel@hunterpr.com</a>.
              <br/>&nbsp;<br/>
              If You would like to limit the disclosure of any personal information we collect about children not related to the completion of a commercial transaction, please contact the legal contact.
            </p>
            <h2 class="privacy-body__heading">13. General Data Protection Regulation</h2>
            <p class="privacy-body__paragraph">
              The EU General Data Protection Regulation (or the “GDPR”) requires Hunter/HPR Partners, LLC and those using our services to provide users with certain information about the processing of their “Personal Data.” “Personal Data” is a term used in Europe that means, generally, data that identifies or can identify a particular unique user or device – for instance, names, addresses, Cookie identifiers, mobile device identifiers, precise location data and biometric data.<br/>
              To comply with the GDPR, we provide the below representations and information, which are specific to persons located in EEA countries or Switzerland (so please don’t rely on the below, if You’re not):
              <br/>&nbsp;<br/>
              <b>a. Legal Grounds for Processing Your Personal Data</b><br/>
              When we act as a “data controller”, the GDPR requires us to tell You about the legal basis we’re relying on to process any Personal Data about You. The legal basis for us processing Your Personal Data for the purposes set out in the “Types of Information We Collect and How We Use It” section above and will typically be because:
              <ul>
                <li>Legitimate Interests. In some cases, we use legitimate interest as a legal basis for processing Personal Data. We rely on legitimate interest when we use Personal Data to maintain the security of our services, and when we communicate with or otherwise manage our client data.</li>
                <li>You provided Your consent.</li>
                <li>Contractual Relationships. Sometimes, we process certain data as necessary under a contractual relationship we have (such as our client records and contact information);</li>
                <li>Legal Obligations. Finally, some processing of data may be necessary for us to comply with our legal or regulatory obligations.</li>
              </ul>
              <b>b. Personal Data Retention</b><br/>
              As a general matter, we retain Your Personal Data for as long as necessary to provide our Website and services, or for other important purposes such as complying with legal obligations, resolving disputes, and enforcing our agreements, as well as for auditing, corporate record-keeping, compliance accounting or security and bug-prevention purposes.
              <br/>&nbsp;<br/>
              <b>c. Your Rights as a Data Subject</b><br/>
              The GDPR provides You with certain rights in respect of Personal Data that data controllers hold about You, including certain rights to access Personal Data, to request correction of the Personal Data, to withdraw Your consent where we process Your Personal Data pursuant to Your consent, to request to restrict or delete Personal Data, and to object to our processing of Your Personal Data (including profiling for online ad targeting). To exercise those rights, You may contact us as described above, in Section 12.
              <br/>&nbsp;<br/>
              However, where we process Personal Data on behalf of a client (which is often the case), we may refer the request to the relevant client and cooperate with their handling of the request, subject to any special contractual arrangement with that client. Many of the rights described here are subject to significant limitations and exceptions under applicable law. For example, objections to the processing of Personal Data, and withdrawals of consent, typically will not have retroactive effect. You also have the right to lodge a complaint with a supervisory authority. However, we hope that You will first consult with us, so that we may work with You to resolve any complaint or concern You might have.
              <br/>&nbsp;<br/>
              <b>If You reside in the EU, following is a more detailed overview of Your rights under GDPR, if it applies to You.<br/>
                You have the right to request:</b>
              <ul>
                <li>Access to the personal data we hold about You, free of charge in most cases.</li>
                <li>The correction of Your personal data when incorrect, out of date or incomplete.</li>
                <li>That we stop using Your personal data for direct marketing (either through specific channels, or all channels).</li>
                <li>That we stop any consent-based processing of Your personal data after You withdraw that consent.</li>
              </ul>
              You can contact us to request to exercise these rights at any time by emailing our legal contacts listed above.
              <br/>&nbsp;<br/>
              If we choose not to take action on Your request, we will explain to You the reasons for our refusal.
              <br/>&nbsp;<br/>
              <b>Your right to withdraw consent</b><br/>
              Whenever You have given us Your consent to use Your personal data, You have the right to change Your mind at any time and withdraw that consent.
              <br/>&nbsp;<br/>
              <b>Where we rely on our legitimate interest</b><br/>
              In cases where we are processing Your personal data on the basis of our legitimate interest, You can ask us to stop for reasons connected to Your individual situation.
              <br/>&nbsp;<br/>
              We must then do so unless we believe we have a legitimate overriding reason to continue processing Your personal data.
              <br/>&nbsp;<br/>
              <b>Direct marketing</b><br/>
              You have the right to stop the use of Your personal data for direct marketing activity through all channels, or selected channels. We must always comply with Your request.
              <br/>&nbsp;<br/>
              <b>Checking Your identity</b><br/>
              To protect the confidentiality of Your information, we will ask You to verify Your identity before proceeding with any request You make under this Privacy Policy.
              <br/>&nbsp;<br/>
              If You have authorised a third party to submit a request on Your behalf, we will ask them to prove they have Your permission to act.
              <br/>&nbsp;<br/>
              <b>Contacting the Regulator – EEA UK and Switzerland Only</b><br/>
              If You feel that Your data has not been handled correctly, or You are unhappy with our response to any requests You have made to us regarding the use of Your personal data, You have the right to lodge a complaint with the Information Commissioner’s Office.<br/>
              You can contact them by calling 0303 123 1113.
              <br/>&nbsp;<br/>
              Or go online to <a href="http://www.ico.org.uk/concerns">www.ico.org.uk/concerns</a> (opens in a new window; please note we can’t be responsible for the content of external websites)<br/>
              If You are based outside the UK, You have the right to lodge Your complaint with the relevant data protection regulator in Your country of residence.
              <br/>&nbsp;<br/>
              <b>Changes to our privacy policy</b><br/>
              By using our Website You consent to our collection and use of Your information as described in this Privacy Policy. We reserve the right to make changes to this Privacy Policy at any time. If we change our privacy policies and procedures, we will post those changes on our Website to keep You aware of what information we collect, how we use it and under what circumstances we may disclose it.
              <br/>&nbsp;<br/>
              <b>I am a California resident. What are my rights with respect to my personal information?</b><br/>
              In addition to the other rights described in this Policy, California residents are also entitled to certain rights under the California Consumer Privacy Act (“CCPA”) with respect to their personal information.  If you are a resident of California (a “Consumer” as defined by the CCPA), this section of the Policy applies to you.  If you are not a Consumer, this section does not apply to you and you should not rely on it.
              <br/>&nbsp;<br/>
              <b>The Right to Access</b><br/>
              Consumers have the right to request certain details about the personal information we have collected about them (generally, within the past 12 months).  Specifically, Consumers have the right to request that we provide them with:
              <ul>
                <li>the specific pieces of personal information and the categories of personal information that we have collected about them</li>
                <li>what categories of the personal information we sold or disclosed for business purposes; and the categories of third parties to whom we sold or disclosed that information for a business purpose</li>
                <li>the categories of sources from which we collected personal information</li>
                <li>categories of third parties with whom we have shared personal information.</li>
              </ul>
              <br/>
              <b>The Right to Deletion</b><br/>
              Consumers have the right to request that we delete the personal information we have collected from them.  In certain circumstances, however, the CCPA allows us to retain information for particular purposes (for example, if we need to retain the information to meet our legal obligations, and for certain other limited reasons set forth by the CCPA).<br/>
              <b>How to Exercise Access and Deletion Rights</b><br/>
              Consumers may submit requests for access to or deletion of their personal information using any of the following methods:<br/>
              <ul>
                <li>Call the following number and leave a message: 212-679-6600</li>
                <li>Email your request to <a href="mailto:smindel@hunterpr.com">smindel@hunterpr.com</a></li>
              </ul>
              For security purposes, we will attempt to verify your identity prior to fulfilling your request.  To verify your identity, we may need to respond or otherwise contact you to request additional information from you (including, but not limited to your name, email address, and mobile advertising ID).  If we are able to verify your identity, we will respond to your request to the extent we are able to and as required by law.  If we cannot verify your identity, we may request additional information from you or we may deny your request.  If we are unable to fulfill your request(s) in their entirety, we will provide further information to you about the reasons that we could not comply with your request.
              <br/>&nbsp;<br/>
              <b>The right to nondiscrimination.</b><br/>
              Consumers have the right not to be discriminated against for exercising their CCPA rights. We will not deny, charge different prices for, or provide a different level of quality of goods or services with respect to consumers who choose to exercise their CCPA rights.<
              <br/>&nbsp;<br/>
              <b>The Right to Opt Out of Sales of Personal Information</b><br/>
              Consumers have the right to opt out of “sales” of their personal information under the CCPA. According to the CCPA, and subject to certain exceptions, a business “sells” personal information when it sells, rents, releases, discloses, disseminates, makes available, transfers, or otherwise communicates orally, in writing, or by electronic or other means, a consumer’s personal information to another business or a third party for monetary or other valuable consideration.<br/>
              Consumers may submit requests to opt out of sales of their personal information using any of the following methods
              <ul>
                <li>Call the following number and leave a message: 212-679-6600</li>
                <li>Email your request to <a href="mailto:smindel@hunterpr.com">smindel@hunterpr.com</a></li>
              </ul>
              <br/>
              <b>Authorized Agents</b><br/>
              Consumers may designate an agent to make CCPA requests on their behalf. For Consumers who do so, we will take steps to verify both the identity of the consumer seeking to exercise their rights as described above, and to verify that the consumer’s agent has been authorized by them to make a request on their behalf by requesting a signed written authorization or a copy of a power of attorney.
            </p>
        </div>
      </div>
  
    </div> 
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .clearfix {
        zoom:1;
        &:before, &:after{ content:""; display:table; }
        &:after{ clear: both; }
    }

    .privacy {
        background-color: #003a4a;
        overflow-x: hidden; 
        position:relative;
        padding: 140px 0 0 0; 
        width: 100%;
    }

    .privacy-body__container {
        box-sizing: border-box;
        opacity: 0;
        margin: 0 0 80px 50px;
        max-width: 1300px;
        padding: 0 50px;
        position: relative;
        transform: translateX(100px);
        z-index: 0;

        @media @breakpoint__tablet--large {
            margin: 0 auto 80px;
        }

        @media @breakpoint__mobile--large {
            margin: 0 auto 40px;
            padding: 0 25px;
        }

        @media @breakpoint__mobile--large {
            margin: 0 auto 40px;
            padding: 0 25px;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    .privacy-side-nav__container {
        position: absolute;
        text-align: right;
        top: 50vh;
        transform: translate(0, -50%);

        .privacy-side-nav__heading {
            color: #dfe6e8;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 36px;
            letter-spacing: 1.5px;
            line-height: 1;
            margin: 0 0 2px;
            text-transform: uppercase;
        }

        .privacyk-side-nav__page-counter-list {
            margin: 0 0 25px;
            padding: 0;

            .privacy-side-nav__page-counter-item {
                background: #cccccd;
                border-radius: 3px;
                display: inline-block;
                height: 6px;
                margin: 0 3px;
                width: 6px;
                z-index: 1;

                &.active {
                    background: #e40046;
                }
            }
        }
    }

    .privacy-side-nav__container--left {
        .privacy-side-nav__container();
        left: 10px;
        text-align: left;

        .work-side-nav__image {
            display: block;
            margin-top: 10px;
        }
    }

    .privacy-header {
        box-sizing: border-box;
        margin: 0 0 30px 50px;
        max-width: 1300px;
        overflow: hidden;
        padding: 0px 100px 0 50px;
        position: relative;
        width: 100%;

        @media @breakpoint__tablet--large {
            margin: 0 auto 30px;
            padding: 0px 50px;
        }

        @media @breakpoint__mobile--large {
            padding: 0 25px;
        }
    }

    .privacy-header__image {
        box-sizing: border-box;
        display: inline-block;
        padding-right: 8%;
        opacity: 0;
        position: relative;
        transform: translateX(200px);
        width: 30%;
        z-index: 0;

        @media @breakpoint__tablet--medium {
            margin-bottom: 50px;
            width: 40%;
        }

        @media @breakpoint__mobile--large {
            width: 80%;
        }
    }

    .privacy-header__content-container {
        display: inline-block;
        margin-bottom: 80px;
        opacity: 0;
        position: relative;
        vertical-align: top;
        width: 70%;
        z-index: 10;

        @media @breakpoint__tablet--medium {
            width: 100%;
        }

        @media @breakpoint__mobile--large {
            margin-bottom: 0;
        }
    }

    .privacy-header__content-wrapper {
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        vertical-align: top;
        width: 50%;

        &:first-child {
  padding-right: 40px;
  }

  @media @breakpoint__tablet--medium {
  margin-bottom: 50px;
  padding: 0 !important;
  width: 100%;
  }
  }

  .privacy-header__heading {
  color: #ffffff;
  margin: 0 0 15px 0;
  font-family: Flama-Bold, Arial, Helvetica, sans-serif;
  font-size: 1.8em;
  letter-spacing: 1px;
  line-height: 1;
  }

  .privacy-header__paragraph {
  color: #fff;
  letter-spacing: 1px;
  line-height: 1.8em;
  margin: 0 0 20px;
  }

  .privacy-header__email {
  border: none;
  border-radius: 5px;
  background: #e40046;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 1em;
  letter-spacing: 1.5px;
  min-width: 130px;
  outline: none;
  padding: 10px;
  text-align: center;
  text-decoration: none;
  z-index: 20;
  }

  .privacy-body__social-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  }

  .privacy-body__social-item {
  display: inline-block;
  margin-right: 50px;

  @media @breakpoint__mobile--small {
  margin-right: 0;
  width: calc(~"100% / 3");
  }
  }

  .privacy-body {
  background: #fff;
  border-top-right-radius: 150px;
  border-bottom-right-radius: 150px;
  padding: 100px 0;
  position: relative;
  max-width: 1500px;
  width: 100%;

  @media @breakpoint__tablet--small {
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  padding: 60px 0;
  }
  }

  .privacy-body__scroll-link {
  display: inline-block;
  left: 10px;
  position: absolute;
  opacity: 0;
  top: 110px;
  z-index: 100;

  @media @breakpoint__tablet--large {
  display: none;
  }
  }

  .privacy-body__scroll-image {
  display: block;
  }

  .privacy-body__headline {
  color: #003a4a;
  font-family: Flama-Bold, Arial, Helvetica, sans-serif;
  font-size: 50px;
  letter-spacing: 1px;
  margin: 0 0 25px 0;
  text-transform: uppercase;
  }
  
  .privacy-body__heading {
  color: #003a4a;
  font-family: Flama-Bold, Arial, Helvetica, sans-serif;
  font-size: 30px;
  letter-spacing: 1px;
  margin: 0 0 25px 0;
  text-transform: uppercase;
  }

  .privacy-body__list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  }

  .privacy-body__list-item {
  display: inline-block;
  padding: 0 12% 0 0;
  width: 280px;
  vertical-align: top;

  @media @breakpoint__tablet--medium {
  box-sizing: border-box;
  width: 50%;
  }

  @media @breakpoint__mobile--large {
  display: block;
  margin-bottom: 40px;
  padding: 0;
  width: 100%;
  }

  &:last-child {
            padding: 0;
        }
    }

    .privacy-body__sub-heading {
        color: #e40046;
        font-size: 22px;
        font-weight: 400;
        letter-spacing: 1px;
        margin: 0 0 20px 0;
    }

    .privacy-body__paragraph {
        color: #003a4a;
        font-size: 16px;
        letter-spacing: 1px;
        line-height: 1.8em;
        margin: 0 0 10px;
    }

    .privacy-body__link {
        color: #003a4a;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        text-decoration: none;
        transition: color 0.5s;

        &:hover {
            color: #e40046;
        }
    }

    .privacy-body__list-item--offices {
        .privacy-body__list-item();
        display: inline-flex;
        padding: 0;
        width: 50%;

        @media @breakpoint__tablet--large {
            margin-bottom: 60px;
            width: 100%;
        }
    }

    .privacy-body__office-details {
        display: inline-block;
        width: 200px;

        @media @breakpoint__tablet--medium {
            width: 40%;
        }

        @media @breakpoint__mobile--large {
            margin-bottom: 30px;
            width: 100%;
        }
    }

    .privacy-body__office-details-sub-heading {
        color: #003a4a;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-weight: 400;
        margin: 0 0 3px;
        text-transform: uppercase;
    }

    .privacy-body__office-details-telephone {
        margin:0 0 15px;
    }

    .privacy-body__office-details-email {
        .privacy-body__link();
        display:block;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-weight: 400;
        margin:0 0 15px;
    }

    .privacy-body__office-details-address {
        .privacy-body__paragraph();
        font-style: normal;
        line-height: 1.4;
        margin-bottom: 15px;
    }

    .privacy-body__office-map {
        box-sizing: border-box;
        display: inline-block;
        flex: 1;
        padding: 0 10% 0 5%;
        position: relative;
        vertical-align: top;

        @media @breakpoint__tablet--large {
            padding: 0 0 0 5%;
            width: 60%;
        }

        @media @breakpoint__mobile--large {
            padding: 0;
            width: 100%;
        }
    }

    .privacy-body__office-map-link {
        display: block;
    }
   
    .privacy-body__office-map-image {
        border-radius: 45px;
        max-width: 425px;
        width: 100%;
    }

    .privacy-body__link--directions {
        .privacy-body__link();
        color: #e40046;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 18px;
        text-decoration: underline;
    }

    .privacy-body-footer {
        background: #003a4a;
        padding: 60px 20px;
    }

    .privacy-body-footer__heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 30px;
        letter-spacing: 1px;
        line-height: 1;
        margin: 0 0 20px 0;
        text-align: center;
    }

    .privacy-body-footer__link-container {
        display: block;
        text-align: center;
    }

    .privacy-body-footer__link {
        background: #e40046;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-size: 1em;
        letter-spacing: 1.5px;
        min-width: 110px;
        padding: 10px;
        text-align: center;
        text-decoration: none;
        z-index: 20;

        &:first-child {
            margin-right: 30px;

            @media @breakpoint__mobile--small {
                display: table;
                margin: 0 auto 20px;
            }
        }
    }
</style>

<script>
    export default {
        name: "privacy",
        created : function()
        {
            var vm = this;
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelSeo))
                {
                    clearInterval(testIfDataLoaded);
                    vm.initAnimIn();
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.to(".header__logo-sub-title-container", 0.2, {width: 0});
        },
        methods: {
            initAnimIn : function()
            {
                var tl = new TimelineMax();
                tl.to(".privacy-header__image", 0.8, {transform: "translateX(0)", opacity: 1, ease: Power2.easeOut});
                tl.to(".privacy-header__content-container", 0.8, {transform: "translateX(0)", opacity: 1}, "-=0.6");
                tl.staggerTo(".privacy-body__container", 0.6, {transform: "translateX(0)", opacity: 1}, 0.2, "-=0.4");
                tl.to(".privacy-body__scroll-link", 0.5, {opacity: 1}, "-=0.4");
                document.querySelector(".header__logo-sub-title").innerHTML = "";
                TweenMax.set(document.querySelector(".header__logo-sub-title-container"), {width: "auto"});
                TweenMax.from(document.querySelector(".header__logo-sub-title-container"), 0.3, {width: 0, delay: 0.2});
            },
            beforeEnterSideNavLeft :function(el) {
                el.style.opacity = 0;
                el.style.transform = "translateX(-110%)";
            },
            enterSideNavLeft : function(el, done) {
                TweenMax.to(el, 0.5, {opacity: 1, transform : "translateX(0)", delay: 2});
            }
        }
    };
</script>
